let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("JqUf8")).then(() => parcelRequire('8cQww'));